import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { uploadBannersCsv, getCsvBannerModel } from '../app/store/actions/banners';
import UploadFilesComponent from '../components/upload';
import BannerImportErrors from '../components/upload/BannerImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadBannersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  sendFile = async (file) => {
    await this.setState({ errors: {} });
    const result = await this.props.uploadBannersCsv(file);
    await this.setState({ errors: (result && result.errors) || [] });
  }

  modelDownload = async () => {
    await this.props.getCsvBannerModel();
  }

  goBack = () => {
    history.push(ROUTES.BANNERS);
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importBanners" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="importText1" /></strong></p>
            <p><Translate value="importText2" /></p>
            <p><Translate value="importText3" /></p>
            <p><Translate value="importText4" /></p>
            <p><Translate value="bannerImportText1" /></p>
            <p><Translate value="bannerImportText2" /></p>
            <p><Translate value="bannerImportText3" /></p>
          </div>


          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            itemsErrors={<BannerImportErrors errors={errors} />}
          />

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadBannersCsv: file => dispatch(uploadBannersCsv(file)),
  getCsvBannerModel: () => dispatch(getCsvBannerModel()),
});

export default connect(null, mapDispatchToProps)(UploadBannersPage);
